import { render, staticRenderFns } from "./front_default.vue?vue&type=template&id=6550d4e1&"
import script from "./front_default.vue?vue&type=script&lang=js&"
export * from "./front_default.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports